angular.module('env.data.repos.customers', [])

    .service("customersRepository", function (rest) {
        var _this = this;
        var modelType = "CustomerModel";
        var modelDefinition = rest.getDefinition(modelType);

        /**
         * Get customers
         * @returns {!Promise.<Array.<RepresentationModel>>} Promise of customers collection
         */
        _this.getCustomers = function () {
            return rest.map(modelDefinition).willReturn(modelType).get();
        };

        /**
         * Get customer by id
         * @param {string} id of the customer
         * @returns {!Promise.<RepresentationModel>} Promise of customer
         */
        _this.getCustomer = function (id) {
            return rest.map(modelDefinition).map(id).willReturn(modelType, id).get();
        };

        /**
         * Get customer delivery addresses by the customer id
         * @param {string} customerId of the customer
         * @returns {!Promise.<Array.<RepresentationModel>>} Promise of addresses collection
         */
        _this.getCustomerDeliveryAddresses = function (customerId) {
            return rest.map(modelDefinition)
                .map(customerId)
                .map("deliveryAddresses")
                .willReturn("AddressModel")
                .get();
        };

        /**
         * Set customer delivery address for a customer
         * @param {string} customerId of the customer
         * @param {string} deliveryAddressId of the customer
         */
        _this.setCustomerDeliveryAddress = function (customerId, deliveryAddressId) {
            return rest.map(modelDefinition)
                .map(customerId)
                .map("deliveryAddresses")
                .map(deliveryAddressId)
                .post();
        };

        //Ordering statistics

        /**
         * Get customers statistics
         * @param {string} [whereOrderItems] 'Where' query to filter out the order items set for statistics. Optional.
         * @param {[]} [forCustomers] Array of customers Ids to get stats for.
         * @returns {!Promise.<Object[]>} promise of users statistics
         */
        _this.getCustomersStatistics = function (whereOrderItems, forCustomers) {
            if (whereOrderItems === null) {
                whereOrderItems = '';
            }
            if (forCustomers == null) {
                forCustomers = [];
            }

            return rest.map('customers', 'statistics').post({where: whereOrderItems, customers: forCustomers});
        };

        /**
         * Get single customer open orders stats
         * @param {string} [whereOrderItems] 'Where' query to filter out the order items set for statistics. Optional.
         * @param {string|number} [forCustomerId] Id of the customer to get orders stats for.
         * @returns {!Promise.<Object[]>} promise of users statistics
         */
        _this.getCustomerOrdersStepsStats = function (forCustomerId, whereOrderItems) {
            if (whereOrderItems === null) {
                whereOrderItems = '';
            }
            if (!forCustomerId) {
                throw new Error('Id of the customer must be specified.');
            }

            return rest
                .map('customers')
                .map(forCustomerId)
                .map('ordersStatistics')
                .post({ where: whereOrderItems });
        };

        /**
         * Get single customer orders history stats
         * @param {string|number} [forCustomerId] Id of the customer to get orders stats for.
         * @param {Date} [from] Get customer orders history stats starting from this date.
         * @param {Date} [to] Get customer orders history stats up to this date.
         * @returns {!Promise.<Object[]>} promise of users statistics
         */
        _this.getCustomerOrdersHistoryStats = function (forCustomerId, from, to) {
            if (!forCustomerId) {
                throw new Error('Id of the customer must be specified.');
            }

            var params = null;

            if (from && to) {
                params = { from: from, to: to };
            }

            return rest
                .map('customers')
                .map(forCustomerId)
                .map('statistics')
                .post(params);
        };

        /**
         * Get all customers simple orders history stats
         * @param {Date} [from] Get customer orders history stats starting from this date.
         * @param {Date} [to] Get customer orders history stats up to this date.
         * @returns {!Promise.<Object[]>} promise of users statistics
         */
        _this.getCustomersOrdersHistoryStats = function (from, to) {

            var params = null;

            if (from && to) {
                params = { from: from, to: to };
            }

            return rest
                .map('customers')
                .map('statistics-simple')
                .post(params);
        };

        //endregion

        return _this;
    })

    .run(function (rest, requestCoupler, requestCouplerUtils) {
        var baserUrl = om.config.build.baseUrl;
        var modelUrl = rest.getDefinition("CustomerModel").getUrl();

        requestCoupler.addCoupler(requestCouplerUtils.createSimpleGetCollectionCoupler(modelUrl, baserUrl + "/" + modelUrl));
    })

;
